import { loadManifest } from '../storage/indexed-db.js';
import { setProgram } from '../state/program-store.js';
import {
  clearInactiveReason,
  evaluatePlaybackFromManifest,
} from '../state/playback-status-store.js';
import { refreshConnectionDisplay } from '../state/connection-status-store.js';
import { showBlackScreen } from '../player/rotation.js';
import { applyProgramPlayback } from './apply-program-playback.js';

/**
 * On online refresh: stop immediately if cached manifest is outside plant hours
 * (black screen) without starting rotation; API sync follows.
 * @param {HTMLElement | null} playerEl
 * @param {Date} [ref]
 */
export async function guardBootPlaybackFromCache(playerEl, ref = new Date()) {
  const manifest = await loadManifest();
  if (!manifest) return false;
  const { shouldPlay } = evaluatePlaybackFromManifest(manifest, ref, { trustApiActive: false });
  if (!shouldPlay) {
    return applyProgramPlayback(manifest, playerEl, ref, { fromCache: true });
  }
  return false;
}

/**
 * Apply cached manifest from IndexedDB (boot / offline poll).
 * @param {HTMLElement | null} playerEl
 * @param {Date} [ref]
 * @returns {Promise<boolean>} true if rotation should be active
 */
export async function applyManifestPlayback(playerEl, ref = new Date()) {
  const manifest = await loadManifest();
  if (!manifest) {
    setProgram(null);
    clearInactiveReason();
    if (playerEl) showBlackScreen(playerEl);
    refreshConnectionDisplay();
    return false;
  }
  return applyProgramPlayback(manifest, playerEl, ref, { fromCache: true });
}
